var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Form as ReactFinalForm, FormSpy } from 'react-final-form';
var FIELD_SUBSCRIPTIONS = ['values', 'errors', 'valid', 'dirty', 'pristine', 'validating'];
var Form = function (props) {
    var children = props.children, mutators = props.mutators, onSubmit = props.onSubmit, initialValues = props.initialValues, onChange = props.onChange, validate = props.validate, validateOnBlur = props.validateOnBlur;
    var formInitialValues = useRef(__assign({}, initialValues));
    var subscribedFields = useRef(FIELD_SUBSCRIPTIONS.reduce(function (fields, prop) {
        var _a;
        return (__assign(__assign({}, fields), (_a = {}, _a[prop] = true, _a)));
    }, {}));
    return (_jsx(ReactFinalForm, __assign({ mutators: mutators, onSubmit: onSubmit, initialValues: formInitialValues.current, validate: validate, validateOnBlur: validateOnBlur }, { children: function (_a) {
            var handleSubmit = _a.handleSubmit;
            return (_jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [children, typeof onChange === 'function' && _jsx(FormSpy, { subscription: subscribedFields.current, onChange: onChange })] })));
        } })));
};
export default Form;
